import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
// import { getWaitScrutinize } from '../../redux/actions/multiReview'
import { startLoading, doneLoading } from '../../utils/loading'
import ProjectWithdrawReviewDataTable from '../dataTable/ProjectWithdrawReviewDataTable'
import {
  getProjectPaymentReview,
  getProjectPaymentReviewByStatus,
  getProjectPaymentReviewApprove,
  getProjectPaymentReviewApproveByStatus,
  downloadPayment,
  searchReviewerPayment,
  searchReviewerPaymentWithStatus,
  searchReviewerPaymentApprover,
  searchReviewerPaymentWithStatusApprover,
  downloadPaymentEForm,
} from '../../redux/actions/withdrawReviewPayment'
import { downloadFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'

export default function ProjectWaitForWithdrawTableWidget({
  schema: _schema,
  onSelectedRowData,
  isApproveTable,
  onShow,
  onChangeShow,
  searchType,
  isApproveSuccess,
  isSaveSuccess,
  statusOptions,
  statusOptionsForApprover,
  ...props
}) {
  const [loading, setloading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState(_schema)
  const [isLoading, setIsLoading] = useState(false)
  let history = useHistory()

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    startLoading()

    let request = {
      projectCode: '',
      projectName: '',
      pageSize: 5,
      pageNumber: 1,
    }

    try {
      let response
      if (isApproveTable) {
        request.status = 2
        response = await searchReviewerPaymentApprover(request)
      } else {
        response = await searchReviewerPayment(request)
      }
      setSchema(response.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetProjectStatusPending = async (pagesize, pagenumber, status, code, name) => {
    console.log('handleGetProjectStatusPending => ', pagesize, pagenumber, status, code, name)
    startLoading()
    setloading(true)

    let requestWithStatus = {
      projectCode: code || '',
      projectName: name || '',
      status: status || null,
      pageSize: pagesize || 5,
      pageNumber: pagenumber || 1,
    }

    let request = {
      projectCode: code || '',
      projectName: name || '',
      pageSize: pagesize || 5,
      pageNumber: pagenumber || 1,
    }

    try {
      if (status === 'all') {
        let response
        if (isApproveTable) {
          request.status = 0
          response = await searchReviewerPaymentApprover(request)
        } else {
          response = await searchReviewerPayment(request)
        }
        setSchema(response.model)
      } else {
        let response
        if (isApproveTable) {
          response = await searchReviewerPaymentWithStatusApprover(requestWithStatus)
        } else {
          response = await searchReviewerPaymentWithStatus(requestWithStatus)
        }

        setSchema(response.model)
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const handleSearchStatus = async (pagesize, pagenumber, status, code, name) => {
    console.log('handleSearchStatus => ', pagesize, pagenumber, status, code, name)
    startLoading()
    setloading(true)

    let requestWithStatus = {
      projectCode: code || '',
      projectName: name || '',
      status: status || null,
      pageSize: pagesize || 5,
      pageNumber: pagenumber || 1,
    }

    let request = {
      projectCode: code || '',
      projectName: name || '',
      pageSize: pagesize || 5,
      pageNumber: pagenumber || 1,
    }

    try {
      if (status === 'all') {
        let response
        if (isApproveTable) {
          request.status = 0
          response = await searchReviewerPaymentApprover(request)
        } else {
          response = await searchReviewerPayment(request)
        }
        setSchema(response.model)
      } else {
        let response
        if (isApproveTable) {
          response = await searchReviewerPaymentWithStatusApprover(requestWithStatus)
        } else {
          response = await searchReviewerPaymentWithStatus(requestWithStatus)
        }

        setSchema(response.model)
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const onShowDetail = (obj) => {
    if (obj) {
      onSelectedRowData(obj)
    }
  }

  const onDownload = async (obj) => {
    startLoading()
    try {
      const file = await downloadPaymentEForm(obj.projectReviewerPaymentId)
      let fileName = 'ใบเบิกจ่าย ' + obj.code
      downloadFile(file, fileName)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  return (
    <>
      {schema && (
        <ProjectWithdrawReviewDataTable
          schema={schema}
          pagination={true}
          onReload={handleGetProjectStatusPending}
          onSearchStatus={handleSearchStatus}
          loading={loading}
          onDownload={onDownload}
          onShowDetail={onShowDetail}
          onShow={onShow}
          onChangeShow={onChangeShow}
          searchType={searchType}
          isApproveSuccess={isApproveSuccess}
          isApproveTable={isApproveTable}
          isSaveSuccess={isSaveSuccess}
          statusOptions={statusOptions}
          statusOptionsForApprover={statusOptionsForApprover}
        />
      )}
    </>
  )
}
